import { useQuery } from '@tanstack/react-query';
import OnboardingFooter from '../../components/OnboardingFooter';
import PricingPlans from '../../views/PricingPlans';
import Loader from '../../components/Loader';
import { useApiClients } from '../../client/api/useApiClient';

export default function PricingPlansPage() {
  const { StripeApi } = useApiClients();
  const { data: plans = [], isLoading } = useQuery({
    queryKey: ['stripeProducts'],
    queryFn: async () => {
      const response = await StripeApi.stripeControllerGetProducts();
      return response?.data?.products || [];
    },
  });

  if (isLoading) {
    return <Loader />;
  }

  return (
    <main className="relative z-10 flex flex-1 flex-col items-center justify-between gap-10 pb-5">
      <PricingPlans plans={plans} />
      <OnboardingFooter />
    </main>
  );
}
